const major = 1;
const minor = 9;
const patch = 15;

module.exports = `${major}.${minor}.${patch}`;
